import { money } from "@/studio/ui";
import { BudgetTable } from "@/studio/ProjectPanels";

const Sec = ({ title, step, onEdit, children }) => (
  <div className="st-sum" data-testid={`summary-section-${step}`}>
    <div className="st-sum__head"><h3>{title}</h3>{onEdit && <button className="st-btn st-btn--quiet st-btn--sm" onClick={() => onEdit(step)} data-testid={`summary-edit-${step}`}>Edit</button>}</div>
    {children}
  </div>
);
const Line = ({ k, v }) => <div className="st-sum__line"><span>{k}</span><span>{v || "—"}</span></div>;
const PEND = { dimensions: "dimensions", openings: "doors/windows", photos: "photos", floorplan: "floor plan" };

export const SummaryView = ({ b, sections, onEdit }) => {
  const rooms = b.project.rooms;
  const pa = b.answers.project || {};
  const ra = (id) => b.answers.rooms?.[id] || {};
  const sel = b.selections;
  const d = sections.includes("discovery");
  const a = sections.includes("assessment");
  const services = Object.entries(pa.services || {}).filter(([, v]) => v).map(([k]) => ({ assembly: "Assembly", shopping: "Personal shopping / styling", photoshoot: "Photoshoot (interest)" }[k]));
  return (
    <div className="st-sums" data-testid="consultation-summary-view">
      {d && <Sec title="Rooms & needs" step={0} onEdit={onEdit}>
        {rooms.map((r) => <Line key={r.id} k={r.label} v={[r.purpose, (ra(r.id).goals || []).join(", ")].filter(Boolean).join(" · ")} />)}
      </Sec>}
      {d && <Sec title="Budget & timeline" step={1} onEdit={onEdit}>
        <BudgetTable rooms={rooms} total={b.project.furniture_total || { min: 0, max: 0 }} testId="summary-budget-total" />
        <p className="st-muted st-small">Furniture budgets exclude design fees, delivery, and assembly.</p>
        <Line k="Design timeline" v={pa.timeline && `${pa.timeline} weeks`} />
        <Line k="Delivery window" v={pa.delivery && `${pa.delivery} weeks`} />
      </Sec>}
      {d && <Sec title="Style & color" step={2} onEdit={onEdit}>
        <Line k="Project styles" v={sel.styles.map((s) => s.name).join(", ")} />
        <Line k="Palettes" v={sel.palettes.map((p) => p.name).join(", ")} />
        {rooms.filter((r) => ra(r.id).own_style && sel.rooms?.[r.id]).map((r) => <Line key={r.id} k={`${r.label} (own style)`} v={[...sel.rooms[r.id].styles, ...sel.rooms[r.id].palettes].map((x) => x.name).join(", ")} />)}
      </Sec>}
      {d && <Sec title="Priorities & deal breakers" step={3} onEdit={onEdit}>
        <Line k="Budget ↔ style" v={pa.budget_style != null && `${pa.budget_style} / 100`} />
        <Line k="Speed ↔ cost" v={pa.speed_cost != null && `${pa.speed_cost} / 100`} />
        <Line k="Deal breakers" v={[...(pa.deal_breakers || []).filter((x) => x !== "Other"), pa.deal_other].filter(Boolean).join(", ")} />
      </Sec>}
      {a && <Sec title="Measurements & photos" step={4} onEdit={onEdit}>
        {rooms.map((r) => {
          const m = b.measurements[r.id] || {};
          const files = b.files.filter((f) => f.room_id === r.id).length;
          const pend = (m.pending || []).map((p) => PEND[p]);
          return <Line key={r.id} k={r.label} v={`${m.computed_sqft ? `${m.computed_sqft} sq ft${m.confirmed ? " · confirmed" : ""}` : "Not measured"} · ${files} file(s)${pend.length ? ` · pending: ${pend.join(", ")}` : ""}`} />;
        })}
      </Sec>}
      {a && <Sec title="Furniture & requirements" step={5} onEdit={onEdit}>
        {rooms.map((r) => {
          const f = Object.entries(ra(r.id).furniture || {});
          const count = (v) => f.filter(([, x]) => x === v).length;
          return <Line key={r.id} k={r.label} v={f.length ? `Keep ${count("keep")} · Replace ${count("replace")} · Add ${count("add")}` : ""} />;
        })}
      </Sec>}
      {a && <Sec title="Optional services" step={6} onEdit={onEdit}><Line k="Interested in" v={services.join(", ") || "None noted"} /></Sec>}
      {!d && !a && <p className="st-muted">{money(0)}</p>}
    </div>
  );
};
